<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">营销系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form label-width="100px" style="margin-top: 20px">
            <el-form-item label="活动模式：" style="display: inline-block">
                <el-select v-model="queryParams.incubatorType">
                    <el-option value="" label="全部"/>
                    <el-option v-for="item in incubatorTypeEnum" :key="item.code" :value="item.value"
                               :label="item.name"/>
                </el-select>
            </el-form-item>

            <el-form-item label="排序方式：" style="display: inline-block">
                <el-select v-model="queryParams.timeType">
                    <el-option v-for="item in sortType" :key="item.value" :value="item.value"
                               :label="item.label"/>
                </el-select>
            </el-form-item>

            <el-form-item label="活动状态：">
                <el-select v-model="queryParams.statesArr" multiple placeholder="请选择活动状态" style="width: 50%">
                    <el-option v-for="item in incubatorStatusEnum" :key="item.code" :value="item.value"
                               :label="item.label"/>
                </el-select>
            </el-form-item>

            <el-form-item label="支付币种：">
                <el-select v-model="queryParams.paymentCoinsArr" filterable multiple placeholder="请选择支付币种"
                           style="width: 50%">
                    <el-option v-for="item in coinTypes" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="优惠币种：">
                <el-select v-model="queryParams.discountCoinsArr" filterable multiple placeholder="请选择优惠币种"
                           style="width: 50%">
                    <el-option v-for="item in coinTypes" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="searchData">搜 索</el-button>
                <el-button type="danger" @click="createDialog" style="margin-left: 20px">创 建</el-button>
            </el-form-item>

        </el-form>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="incubatorName" label="名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.incubatorName | langjson}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="incubatorCoin" label="币种" show-overflow-tooltip></el-table-column>
            <el-table-column prop="paymentCoin" label="支持币种" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.paymentCoin | arrFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="lang" label="支持语言" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.lang | langFormat}}</span>
                </template>
            </el-table-column>

            <el-table-column prop="totalAmount" label="总数量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualTotalAmount" label="实际数量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nowAmount" label="当前数量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="price" label="价格" show-overflow-tooltip></el-table-column>
            <el-table-column prop="incubatorType" label="活动模式" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.incubatorType | incubatorTypeFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="distributionType" label="分配模式" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.distributionType | distributionTypeFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="开始时间" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.startTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="结束时间" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.endTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="公布时间" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.publicTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="state" label="状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.state | stateFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="state" label="上架/下架" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.onlineState" active-color="#13ce66" inactive-color="#ff4949"
                               @change="alterState(scope.row.id,$event)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="280px">
                <template slot-scope="scope">
                    <el-button type="primary" @click="handleOrder(scope.row.id)">订单</el-button>
                    <el-button type="primary" @click="handleDetail(scope.row.id)">编辑</el-button>
                    <el-button type="danger" @click="deleteIncubator(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <!--创建弹框-->
        <CreateIncubator @refresh="searchData"/>
        <!--订单弹框-->
        <OrderList @refresh="searchData"/>
    </div>
</template>

<script>
    import './store';
    import api from './api';
    import {mapState, mapMutations, mapActions, mapGetters} from "vuex";
    import {
        INCUBATOR_TYPE_ENUM,
        INCUBATOR_STATUS_ENUM,
        SORT_TYPE,
        INCUBATOR_DISTRIBUTION_MODEL_ENUM
    } from "./constants";
    import LANGUAGES from "../../../common/languages_code";
    import CreateIncubator from "./components/create";
    import OrderList from "./components/orderList";

    export default {
        name: "IncubatorManage",
        components: {
            CreateIncubator,
            OrderList
        },
        data() {
            return {
                dataList: [], //申购列表
                total: 0, //总条数
                queryParams: { //查询参数
                    incubatorType: "",
                    paymentCoinsArr: [],
                    discountCoinsArr: [],
                    statesArr: [],
                    paymentCoins: "",
                    discountCoins: "",
                    states: "",
                    timeType: 4,
                    page: 1,
                    size: 10
                },
                coinTypes: [],
                incubatorTypeEnum: INCUBATOR_TYPE_ENUM,
                incubatorStatusEnum: INCUBATOR_STATUS_ENUM,
                sortType: SORT_TYPE,
            };
        },
        filters: {
            stateFormat(val) {
                let value = INCUBATOR_STATUS_ENUM[val];
                if (value) {
                    return value.label;
                }
                return "";
            },
            distributionTypeFormat(val) {
                let value = INCUBATOR_DISTRIBUTION_MODEL_ENUM.find(x => x.value == val);
                if (value) {
                    return value.name;
                }
                return "";
            },
            incubatorTypeFormat(val) {
                let value = INCUBATOR_TYPE_ENUM.find(x => x.value == val);
                if (value) {
                    return value.name;
                }
                return "";
            },
            langFormat(val) {
                if (val) {
                    let langArr = JSON.parse(val);
                    let s = "";
                    for (let i = 0; i < langArr.length; i++) {
                        if (i == 0) {
                            s += LANGUAGES[langArr[i]];
                        } else {
                            s += "," + LANGUAGES[langArr[i]];
                        }
                    }
                    return s;
                } else {
                    return "";
                }
            },
            arrFormat(val) {
                if (val) {
                    let arr = JSON.parse(val);
                    return arr.join(",");
                } else {
                    return "";
                }
            }
        },
        methods: {
            ...mapMutations("IncubatorManage", ["toggleCreateDialogVisible", "toggleOrderDialogVisible"]),
            ...mapActions("IncubatorManage", ["setCurrId", "setCoinTypes", "setPairTypes", "setCountry", "setChain"]),
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                    this.setCoinTypes(data);
                });
            },
            getAllSupportingPairs() {
                api.getAllSupportingPairs().then(({data}) => {
                    this.setPairTypes(data);
                });
            },
            getAllCountry() {
                api.getAllCountry().then(({data}) => {
                    this.setCountry(data);
                });
            },
            getAllChain() {
                api.getAllChain().then(({data}) => {
                    this.setChain(data);
                });
            },
            searchData() {
                this.queryParams.page = 1;
                this.getIncubatorList();
            },
            getIncubatorList() {
                this.queryParams.paymentCoins = this.queryParams.paymentCoinsArr.join(",")
                this.queryParams.discountCoins = this.queryParams.discountCoinsArr.join(",")
                this.queryParams.states = this.queryParams.statesArr.join(",")
                api.getIncubatorList(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getIncubatorList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getIncubatorList();
            },
            alterState(id, state) {
                this.$confirm(state ? '确认上架吗？' : '确认下架吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateOnline({id: id, online: state}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.getIncubatorList();
                    });
                }).catch(() => {
                });
            },
            deleteIncubator(id) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteIncubator({id: id}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.getIncubatorList();
                    });
                }).catch(() => {
                });
            },
            handleDetail(id) {
                this.setCurrId(id);
                this.toggleCreateDialogVisible(true);
            },
            handleOrder(id) {
                this.setCurrId(id);
                this.toggleOrderDialogVisible(true);
            },
            createDialog() {
                this.setCurrId(null);
                this.toggleCreateDialogVisible(true);
            }
        },
        created() {
            this.getAllSupportCoin();
            this.getAllSupportingPairs();
            this.getAllCountry();
            this.getAllChain();
            this.getIncubatorList();
        }
    }
</script>

<style scoped>

</style>